<template>
  <div id="app">
    <navbar/>
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

import Navbar from "./components/home/Navbar";
export default {
  name: "app",
  computed: {},
  components: {
    Navbar
  },
  created() {
    this.$store.dispatch("iniciarAtualizacao");
  },
  beforeDestroy() {
    this.$store.dispatch("destroy");
  }
};
</script>

<style>
</style>
